import { GemiusService } from './analytics/GemiusService';
import { AppWebService } from './analytics/AppWebService';
import { SetVpObj } from './core/SetVpObj';
import { getVideoConfig, randomString, sanitizeKw } from './utils/playerUtils';
import { browserIsMobile } from './utils/CheckBrowser';

/**
 * @description VP stream player
 * @author Milan Machacek <milan1.machacek@cncenter.cz>
 * @version 1.0.0
 * @create 2019-08-01
 *
 */

/* eslint-disable camelcase */

export async function CncVpStreamPlayer(config) {
    const self = {};
    self.version = '1.1.0-stream';
    self.settings = {};
    self.configCNC = {};
    self.isMobile = browserIsMobile();

    // Provedení fetch pouze pokud existuje videoPlayerId
    let data = {};
    if (
        config &&
        config.configCNC &&
        config.configCNC.video &&
        typeof config.configCNC.video.videoPlayerId !== 'undefined' &&
        config.configCNC.video.videoPlayerId !== ''
    ) {
        const fetchUrl = `https://host.vpplayer.tech/player/${config.configCNC.video.videoPlayerId}.json?v=${Date.now()}`;
        data = await fetch(fetchUrl).then((r) => r.json());
    }

    Object.assign(self.settings, data); // zachová vše z fetchu

    // Aktualizuj pouze konkrétní hodnoty z configu samotny file se pridava pozdeji kvuli dvema implementacim
    if (!self.settings.video) self.settings.video = {};
    Object.assign(self.settings.video, {
        thumbnail: config.video.poster || self.settings.video.thumbnail || '',
        live: true,
        liveType: 'realtime',
        advertising: config.video.advertising,
    });

    if (!self.settings.config) self.settings.config = {};
    Object.assign(self.settings.config, {
        autostartOnViewable: {
            state: config.video.autoplay === true,
            onMobile: config.video.autoplay === true,
            onData: config.video.autoplay === true,
        },
        logo: {
            state: config.logo !== '',
            file: config.logo || '',
            position: 'TOP_LEFT',
            style: {
                width: 'auto',
            },
        },
    });

    self.settings.videoData = config.video;
    self.settings.adServerPath = config.adServerPath;
    self.settings.viewId = randomString(12);

    if (!self.settings.category) self.settings.category = {};
    Object.assign(self.settings.category, {
        magazine: config.realMag,
    });

    self.settings.appWeb = config.appWeb;

    self.settings.videoData.category = {
        magazine: config.realMag,
        magazineName: 'onlinestream',
    };

    // get config for online stream
    let cfg = getVideoConfig(`${config.realMag}-live`, 0, '', self.isMobile);
    // if not config for online stream, get config for stream
    if (!cfg) {
        cfg = getVideoConfig(config.realMag, 0, '', self.isMobile);
        cfg.gemius.series = 'Online Stream';
        cfg.gemius.prefix = 'onlinestream';
    }
    // set gemius custom attribute 1
    cfg.gemius.typePlayer = 'Online Stream';

    self.settings.gemius = cfg.gemius;
    self.settings.ads = cfg.ads;
    self.settings.video.site = cfg.ads.site;
    self.settings.video.area = cfg.ads.area;

    // for GA4
    self.settings.videoData.category.magazineName = cfg.magazineName;

    // url for m3u8 from our BE or for m3u8 source from livebox script
    if (config.video.liveboxStreamURL && config.video.liveboxStreamURL !== '') {
        self.src = config.video.liveboxStreamURL;
    } else if (config.archive) {
        self.src = window.LiveboxArchSource.link_for(config.cn, 'hls');
    } else if (typeof window.LiveboxLinkSource === 'undefined') {
        self.src = window.LiveboxLiveSource.link_for(config.cn, 'hls');
    } else {
        self.src = window.LiveboxLinkSource.link_for(config.cn, 'hls');
    }

    self.cnt = 0;
    self.time = 0;
    self.SetVpObj = new SetVpObj();

    // init player on element
    self.player = window.vpPlayer(self.settings.videoData.elementId);

    /**
     * AppWebservice odesilame na jednom miste, abychom nemuseli pred kazdym odeslanim kontrolovat zdali mame
     * @param serviceFunction
     * @param settingObject
     * @returns {null|boolean}
     */
    self.sendAppService = (serviceFunction, settingObject) =>
        new Promise((resolve) => {
            if (self.appWebService && serviceFunction in self.appWebService) {
                self.appWebService[serviceFunction](settingObject);
                resolve(true);
            }
            resolve(false);
        });
    // settings AppWeb, if is settings in bin/cncVideoConfig.js
    if (self.settings.appWeb.contentType === 'live' && cfg.appweb && cfg.appweb.active) {
        self.settings.appWeb.show = cfg.gemius.series;
        self.settings.appWeb.playerType = self.settings.videoData.miniplayer
            ? 'videoMini'
            : 'videoNormal';
        self.appWebService = new AppWebService({
            video: self.settings.videoData,
            appWeb: self.settings.appWeb,
        });
    }

    self.construct = () => {
        if (typeof self.src === 'undefined') {
            self.time += 500;
            self.cnt += 1;
            if (self.cnt < 5) {
                setInterval(() => {
                    self.construct();
                }, self.time);
            }
        } else {
            // const cnf = self.SetVpObj;
            // cnf.video = self.settings.video;
            self.configCNC.viewId = self.settings.viewId;

            // promenna kvuli odesilani do appwebu - obcas se stane ze prehravac odesle event "play" dvakrat
            self.configCNC.eventPlaySend = false;
            self.configCNC.eventResumeSend = false;

            // livebox stream from our BE
            if (config.video.liveboxStreamURL && config.video.liveboxStreamURL !== '') {
                self.settings.video.file = self.src;

                // remova advertising if in kw is no-ad
                // if (self.settings.videoData.keywords.indexOf('no-ad') > -1) {
                //     cnf.advertising = {};
                // } else {
                //     // set advert
                //     Object.keys(cnf.advertising.schedule).forEach((key) => {
                //         cnf.advertising.schedule[key].tag = self.setAdUrl(
                //             cnf.advertising.schedule[key].tag,
                //         );
                //     });
                // }

                self.player.setup(self.settings);
                self.player.on('vpEvent', self.VPAPandMeasurement);
            } else {
                // livebox hack redirect m3u8
                const xhr = new XMLHttpRequest();
                xhr.open('GET', self.src);
                xhr.send();
                xhr.onload = () => {
                    self.settings.video.file = xhr.responseURL;

                    self.player.setup(self.settings);
                    self.player.on('vpEvent', self.VPAPandMeasurement);
                };
            }
        }
    };

    // set variable in advert url
    self.setAdUrl = (path) => {
        const ret = path
            .replace('__item-viewid__', randomString(12))
            .replace('__item-template__', 'stream')
            .replace('__item-area__', self.settings.videoData.area)
            .replace('__item-site__', self.settings.videoData.site)
            .replace('__item-keywords__', '');

        return ret + sanitizeKw(self.settings.videoData.keywords);
    };

    // gemius maping
    self.mapGemius = (obj) => {
        Object.keys(obj).forEach((key) => {
            obj[key] = typeof obj[key] !== 'string' ? '' : obj[key];
        });

        obj.prefix = self.settings.gemius.prefix;

        return obj;
    };

    /**
     * @description - obsluha eventu - VPAP a měření
     * @param {event} evt
     *
     */
    self.VPAPandMeasurement = (evt) => {
        let eventName;
        if (evt) {
            eventName = evt.eventName ? evt.eventName : 'none';
        }

        // TODO overit jestli funguje neznama promenna
        const { info } = window;
        // const actualQuality = info.levels[info.currentQuality];
        // const resolution =
        //     actualQuality.label.toLowerCase() === 'auto'
        //         ? 'auto'
        //         : `${actualQuality.width}x${actualQuality.height}`;
        const resolution = 'auto';

        switch (eventName) {
            // video player is initialized and ready
            case 'ready':
                // setting Gemius prism
                self.gemiusService = new GemiusService({
                    gemius: self.settings.gemius,
                    video: self.settings.videoData,
                });

                self.playTime = 0;

                if (self.appWebService && self.playTime === 0) {
                    self.appWebService.sentPlayerData({
                        eventType: 'player_start',
                        type: 'stream',
                        time: self.player.getPosition(),
                        clear: true,
                    });
                }

                // inicializace proměnné pro měření reklam
                self.adPlayTime = 0;

                break;

            // video play
            case 'play':
                // uložíme čas přehrávání
                self.playTime = self.player.getPosition();

                // další spuštění videa - play/resume
                if (self.playTime !== 0 && !self.configCNC.eventPlaySend) {
                    self.configCNC.eventPlaySend = true;
                    self.sendAppService('sentPlayerData', {
                        eventType: 'player_play',
                        type: 'stream',
                        timePosition: self.playTime,
                    });

                    // odesleme event i do gemiusu
                    self.gemiusService.sendHit(self.playTime, 'play');
                } else if (self.playTime >= 10) {
                    // kazdy dalsi event resume
                    self.sendAppService('sentPlayerEventWithTime', {
                        eventType: 'player_resume',
                        timePosition: self.playTime,
                    });
                }

                break;

            // start playing
            case 'firstFrame':
                self.playTime = Math.round(self.player.getPosition());
                break;

            // on playing
            case 'time':
                self.playerProgress({
                    actualTime: self.player.getPosition(),
                    oldTime: self.playTime,
                });
                break;

            case 'playlistItem':
                break;

            // video pause
            case 'pause':
                self.sendAppService('sentPlayerEventWithTime', {
                    eventType: 'player_pause',
                    type: 'stream',
                    timePosition: self.player.getPosition(),
                });
                self.gemiusService.sendHit(self.player.getPosition(), 'pause');
                break;

            // seek
            case 'seek':
                self.sendAppService('sentPlayerEventWithTime', {
                    eventType: 'player_seeking',
                    type: 'stream',
                    timePosition: evt.currentTime,
                });
                break;

            // seeked
            case 'seeked':
                self.gemiusService.sendHit(self.player.getPosition(), 'seek');
                self.sendAppService('sentPlayerEventWithTime', {
                    eventType: 'player_seeking',
                    type: 'stream',
                    timePosition: self.player.getPosition(),
                });
                self.playTime = Math.round(self.player.getPosition());
                break;

            // buffer change
            case 'bufferChange':
                self.gemiusService.sendHit(self.player.getPosition(), 'buffer');
                break;

            // buffer full
            case 'bufferFull':
                if (evt.currentTime > 0) {
                    self.sendAppService('sentPlayerEventWithTime', {
                        eventType: 'player_buffering',
                        type: 'stream',
                        timePosition: self.player.getPosition(),
                    });
                }
                break;

            // changing volume (info = {volume: 52.840, type: "volume"})
            case 'volume':
                self.gemiusService.sendHit(self.player.getPosition(), 'chngVol');
                break;

            // mute
            case 'mute':
                self.sendAppService('sentPlayerSetting', {
                    eventType: 'player_settings_change_mute',
                    type: 'stream',
                    item: 'mute',
                    itemValue: evt.muted,
                    timePosition: evt.currentTime,
                });
                break;

            // change quality
            case 'levelsChanged':
                self.gemiusService.sendHit(self.player.getPosition(), 'chngQual');

                self.sendAppService('sentPlayerSetting', {
                    eventType: 'player_settings_change_resolution',
                    type: 'stream',
                    item: 'resolution',
                    itemValue: resolution,
                    timePosition: self.player.getPosition(),
                });
                break;

            // auto changing quality
            case 'visualQuality':
                self.gemiusService.sendHit(self.player.getPosition(), 'chngQual');
                break;

            // before complete
            case 'beforeComplete':
                break;

            // complete
            case 'complete':
                self.gemiusService.sendHit(self.player.getPosition(), 'complete');
                self.sendAppService('sentPlayerEventWithTime', {
                    eventType: 'player_end',
                    type: 'stream',
                    timePosition: self.player.getPosition(),
                });
                break;

            // float
            case 'float':
                self.sendAppService('setPlayerProperty', {
                    propertyName: 'playerVariant',
                    propertyValue: evt.floating === true ? 'floating' : 'standard',
                });
                self.sendAppService('sentPlayerData', {
                    eventType: '',
                    type: 'stream',
                    time: self.player.getPosition(),
                    clear: true,
                });
                break;

            // fullscreen
            case 'fullscreen':
                self.gemiusService.sendHit(self.player.getPosition(), 'chngRes');
                self.sendAppService('sentPlayerSetting', {
                    eventType: 'player_settings_change_fullscreen',
                    type: 'stream',
                    item: 'fullscreen',
                    itemValue: evt.fullscreen,
                    timePosition: evt.currentTime,
                });
                break;

            // error
            case 'error':
                // TODO error
                break;

            // advertising events
            case 'adImpression':
                if (self.appWebService) {
                    self.sendAppService('sentAdList', {
                        eventType: 'player_ads_loaded',
                        id: evt.adPlayId,
                        length: evt.adDuration,
                        type: 'video',
                        slot: evt.adPosition,
                        adPosition: evt.adPosition,
                    });
                }

                break;

            case 'adClick':
                if (self.appWebService) {
                    self.sendAppService('sentAdPlay', {
                        eventType: 'player_ads_click',
                        id: evt.adPlayId,
                    });
                }

                break;

            case 'adPause':
                if (self.appWebService) {
                    self.sendAppService('sentAdPlay', {
                        eventType: 'player_ads_pause',
                        id: evt.adPlayId,
                    });
                }
                // gemius
                self.gemiusService.sendAdHit(evt.currentTime, 'pause', evt.adPlayId);

                break;

            case 'adPlay':
                if (self.appWebService) {
                    self.sendAppService('sentAdPlay', {
                        eventType:
                            evt.afterPause === true ? 'player_ads_resume' : 'player_ads_play',
                        id: evt.adPlayId,
                    });
                }
                // gemius
                self.gemiusService.sendAdHit(evt.currentTime, 'play', evt.adPlayId);

                break;

            case 'adSkippable':
                if (self.appWebService) {
                    self.sendAppService('sentAdPlay', {
                        eventType: 'player_ads_skippable',
                        id: evt.adPlayId,
                        position: evt.currentTime,
                    });
                }

                break;

            case 'adSkipped':
                if (self.appWebService) {
                    self.sendAppService('sentAdPlay', {
                        eventType: 'player_ads_skip',
                        id: evt.adPlayId,
                        position: self.adPosition,
                    });
                }

                break;
            case 'adComplete':
                if (self.appWebService) {
                    self.sendAppService('sentAdPlay', {
                        eventType: 'player_ads_end',
                        id: evt.adPlayId,
                    });
                }
                // gemius
                self.gemiusService.sendAdHit(evt.currentTime, 'complete', evt.adPlayId);

                break;
            case 'adTime':
                if (self.appWebService) {
                    // self.sendAppService('sentAdPlay', {
                    //     eventType: 'player_ads_progress',
                    //     id: evt.adPlayId,
                    //     position: self.adPosition,
                    // });

                    setTimeout(self.adProgress, 0, {
                        actualAdTime: evt.currentTime,
                        oldAdTime: self.adPlayTime,
                        adId: evt.adPlayId,
                    });
                }

                break;

            default:
        }
    };

    /**
     * @description - funkce pro odesílání události player_progress do dataLayeru každých 5s
     *
     * @param {object} timeData - objekt s časovými údaji
     * @param {number} timeData.actualTime - aktuální čas přehrávání videa (s)
     * @param {number} timeData.oldTime - čas uložený při posledním odeslání události do objectu playeru
     */
    self.playerProgress = (timeData) =>
        new Promise((resolve) => {
            const actualTime = Math.round(timeData.actualTime);
            const { oldTime } = timeData;
            const playerProgress = actualTime - oldTime;

            if (playerProgress > 4) {
                self.sendAppService('sentPlayerEventWithTime', {
                    eventType: 'player_progress',
                    timePosition: actualTime,
                });
                self.playTime = actualTime;
            }
            resolve();
        });

    /**
   * @description - funkce pro odesílání události player_ads_progress do dataLayeru každých 5s
   *
   * @param {object} adTimeData - objekt s časovými údaji a s id přehrávabé reklamy
   * @param {number} adTimeData.actualAdTime - aktuální čas přehrávané reklamy (s)
   * @param {number} adTimeData.oldAdTime - čas uložený při posledním odeslání události do objectu playeru

   * @param {string} adTimeData.adPlayId - id přehrávabé reklamy
   */
    self.adProgress = (adTimeData) => {
        const actualAdTime = Math.round(adTimeData.actualAdTime);
        const playAdProgress = actualAdTime - adTimeData.oldAdTime;

        if (playAdProgress > 9) {
            self.sendAppService('sentAdPlay', {
                eventType: 'player_ads_progress',
                id: adTimeData.adId,
                timePosition: actualAdTime,
            });
            self.adPlayTime = actualAdTime;
        }
    };

    /**
     * listener pro sledování  události open na [sharing] pluginu a odeslání do datalayeru
     */
    self.shareEvent = () => {
        self.sendAppService('sentPlayerEventWithTime', {
            eventType: 'player_sharing_open',
            timePosition: self.player.getPosition(),
        });
    };

    self.configCNC.gemius = cfg.gemius;
    window.cncGjvpPlayers.push(self);
    return self;
}
